<template>
    <div>
        <div class="card-header py-3">
            <small><strong>{{ lang.app.subscription.pending_screen.pending_title }}</strong></small>
            <br/>
            <small style="font-size: 0.9rem;">{{ lang.app.subscription.first_product_subscription.sub_title }}
            </small>
        </div>
        <div class="card-body">
            <h6>{{ lang.app.subscription.pending_screen.tool.line1 }}</h6>
            <h6 class="mt-2">{{ lang.app.subscription.pending_screen.tool.line2 }}</h6>
            <div class="mt-5">
                <h6>{{ lang.app.subscription.pending_screen.tool.remarks }}</h6>
                <h6 class="mt-2">{{ lang.app.subscription.pending_screen.tool.remarks_contact }} <strong><a
                        href="mailto:info@farmdesk.eu" class="color-tool">info@farmdesk.eu</a></strong></h6>
                <h6 class="mt-2">{{ lang.app.subscription.pending_screen.tool.bottom_text_team }} </h6>
            </div>
        </div>
    </div>
</template>
<script>
    export default {}
</script>



// WEBPACK FOOTER //
// resources/js/components/subscription/tool/SetupPendingScreen.vue